"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[NoOpDeviceBroker]] rejects requests to acquire a [[MediaStream]].
 */

var NoOpMediaStreamBroker = /*#__PURE__*/function () {
  function NoOpMediaStreamBroker() {
    _classCallCheck(this, NoOpMediaStreamBroker);
  }

  _createClass(NoOpMediaStreamBroker, [{
    key: "acquireAudioInputStream",
    value: function acquireAudioInputStream() {
      return Promise.reject();
    }
  }, {
    key: "acquireVideoInputStream",
    value: function acquireVideoInputStream() {
      return Promise.reject();
    }
  }, {
    key: "acquireDisplayInputStream",
    value: function acquireDisplayInputStream(_streamConstraints) {
      return Promise.reject();
    }
  }, {
    key: "releaseMediaStream",
    value: function releaseMediaStream(_mediaStreamToRelease) {}
  }, {
    key: "bindToAudioVideoController",
    value: function bindToAudioVideoController(_audioVideoController) {}
  }]);

  return NoOpMediaStreamBroker;
}();

exports.default = NoOpMediaStreamBroker;